export default __webpack_public_path__ + "static/media/link.cd0ed69d.svg";